export class FormInputCode
{
	static PRODUCT_SELECTOR = 'product-selector';
	static IMAGE_EDITOR = 'image-editor';
	static QUANTITY = 'quantity';
	static PRICE = 'price';
	static RESULT = 'result';
	static DISCOUNT = 'discount';
	static TAX = 'tax';
	static BRAND = 'brand';
	static MEASURE = 'measure';
}